module.exports = __webpack_public_path__ + "img/serve_08@2x.5ad5fa43.png";